import { ICartItem } from '../interfaces/ICartItem';

export const calcOrderPriceWOPromo = (item: ICartItem): number => {
  let baseProductsPrice = 0;
  let sumComponentsPrices = 0;

  if (item.childOrderItems.length || item.gridProduct) {
    if (item.compositeProduct.product.controlGrid === 2) {
      baseProductsPrice =
        item.childOrderItems
          .map((pizza) => pizza.produto.grids[0].price.value * pizza.quantidade)
          .reduce((total, next) => total + next) * item.quantity;
    } else {
      baseProductsPrice = (item.gridProduct?.price.value || 0) * item.quantity;
    }
  } else {
    baseProductsPrice =
      +item.compositeProduct.product.price.value * item.quantity;
  }

  if (item.compositeProduct.complements.length) {
    sumComponentsPrices = item.compositeProduct.complements
      .map(
        (complemento) =>
          +complemento.complement.price.value *
          complemento.quantity *
          item.quantity,
      )
      .reduce((total, next) => total + next);
  }
  return Number((baseProductsPrice + sumComponentsPrices).toFixed(2));
};
